var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"consultationRecordList"},[(_vm.list.length)?_c('div',[_c('StudentListTable',{attrs:{"list":_vm.list,"userType":_vm.userType}}),_c('Pagination',{attrs:{"pageData":_vm.pageData},on:{"changePage":_vm.changeCurrent}})],1):_c('div',{staticClass:"noContent"},[_c('NoContent')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }